import { Tooltip as TooltipComponent } from 'antd';
import { FC, ReactNode } from 'react';
import { TooltipPlacement } from 'antd/es/tooltip';
import classNames from 'classnames';

type PopoverProps = {
	title: string | ReactNode;
	placement?: TooltipPlacement;
	children: ReactNode;
	className?: string;
};

export const Tooltip: FC<PopoverProps> = ({ title, children, placement = 'top', className }) => {
	return (
		<TooltipComponent
			title={title}
			overlayClassName={classNames('popover', { [`${className}`]: className })}
			placement={placement}
		>
			{children}
		</TooltipComponent>
	);
};
